import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { baseApiUrl } from "../service/base-url";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Pagination from "../components/Pagination";

const Work = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const language = useSelector((state) => state.language.language);
    const [links, setLinks] = useState(null)
      const fetchProduct = async (page=1) => {
      try {
        const response = await axios.get(`${baseApiUrl}/categories/child/${id}/products?page=${page}`, {
          headers: { 'Content-Type': 'application/json','x-localization': language }

        })
        const dataRes = response.data
        if (dataRes) {
          setProduct(dataRes.data)
          setLinks(dataRes.links)
        }
      } catch (error) {
        toast.error('Please try again.')
        console.error('Error:', error)
      }
    }

  useEffect(() => {


    fetchProduct();
  }, [id, language]);


  if (!product) return <p>Loading...</p>;
  
  return (
    <>
      <div
          className='bg-white sm:px-8 flex justify-center'>
              <div className="w-full mt-12 justify-around items-center flex-wrap flex-col lg:flex-row flex gap-x-3">
                    {product.map((item,index) => {                      
                      return (
                        <Link className="mt-8" key={index} to={`/products/${item.id}`}>
                          <div className="flex flex-col justify-between w-[100%] lg:w-[100%]">
                            <img className="w-full max-w-[330px] 2xl:max-w-[300px] object-contain md:object-cover max-h-[300px] min-h-[280px] md:min-h-[300px]" alt="png" src={item?.images[0]?.url}/>
                            <div className="mt-3">
                              <p className="text-darkBg  font-customFont font-light text-[22px] two-line-truncate max-w-[428px]">{item.name}</p>
                              <p className="text-darkBg  font-customFont font-light text-lg">{item.title} /  # {item.code}</p>
                              {item.is_actual ? <p className="text-green-600 font-customFont font-light text-lg">Available</p> :
                              <p className="text-red-700  font-customFont font-light text-[22px]">Not available</p> }
                            </div>
                          </div>
                        </Link>
                      )
                    })}
                  </div>
          </div>

    
      {links && (
        <div
          className="flex justify-center items-center py-2 cursor-pointer"
        >
          <Pagination fetchData={fetchProduct} links={links} />
     

        </div>
      )}
    </>
      
  );
};

export default Work;
